import moment from 'moment';
import { PaymentState } from '../types';

export const getPolicyStartAndEndDate = (
  paymentState: PaymentState,
  format: string
) => {
  const periodItem = {
    startDate: '',
    endDate: '',
  };

  const { dates } = paymentState.policy;

  if (dates) {
    periodItem.startDate = moment(dates.effective).format(format);
    periodItem.endDate = moment(dates.expiry).format(format);
  }

  return periodItem;
};
